import axios from 'axios';
import { API_END_POINT } from './api';

export async function log(log: string) {
  const data = {
    log,
  };
  return axios.post(`${API_END_POINT}/public/logging`, data);
}
